/**
 * @public
 */
export class Header {
    static of(name, value) {
        return new Header(name, value);
    }
    _name;
    _value;
    constructor(name, value) {
        this._name = name;
        this._value = value;
    }
    get name() {
        return this._name;
    }
    get value() {
        return this._value;
    }
    equals(value) {
        return (value instanceof Header &&
            value._name === this._name &&
            value._value === this._value);
    }
    toJSON(options) {
        return {
            name: this._name,
            value: this._value,
        };
    }
    toEARL() {
        return {
            "@context": {
                http: "http://www.w3.org/2011/http#",
            },
            "@type": "http:MessageHeader",
            "http:fieldName": this._name,
            "http:fieldValue": this._value,
        };
    }
    toString() {
        return `${this._name}: ${this._value}`;
    }
}
/**
 * @public
 */
(function (Header) {
    function from(json) {
        return Header.of(json.name, json.value);
    }
    Header.from = from;
    function isHeader(value) {
        return value instanceof Header;
    }
    Header.isHeader = isHeader;
})(Header || (Header = {}));
//# sourceMappingURL=header.js.map